import { Brain, CheckCircle, Users, Zap } from "lucide-react";
import Footer from "@/components/Footer";
import Logo from "@/components/Logo";

const NEXT_STEPS = [
  <>
    <strong className="font-semibold text-ink-900">Luisa, nossa IA SDR</strong>, vai te chamar no WhatsApp
  </>,
  <>
    Ela fará <strong className="font-semibold text-ink-900">perguntas rápidas</strong> sobre seu negócio
  </>,
  <>
    Se houver fit, ela agendará uma <strong className="font-semibold text-ink-900">reunião com nosso consultor sênior</strong>
  </>,
];

const WHY_AI_FIRST = [
  { icon: Zap, text: "Economia de tempo para todos" },
  { icon: CheckCircle, text: "Diagnóstico mais preciso" },
  { icon: Users, text: "Você fala apenas sobre soluções viáveis" },
];

const ThankYou = () => (
  <div className="min-h-screen bg-paper">
    <header className="fixed inset-x-0 top-0 z-50 border-b border-ink-900/[0.06] bg-white/95 backdrop-blur-xl">
      <div className="mx-auto flex h-[72px] max-w-page items-center justify-center px-5 sm:px-8">
        <Logo />
      </div>
    </header>

    <main className="relative overflow-hidden pb-20 pt-[72px]">
      <div aria-hidden="true" className="bg-grid mask-fade-top pointer-events-none absolute inset-0" />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-40 right-[-12%] h-[560px] w-[560px] rounded-full bg-brand-400/20 blur-[140px]"
      />

      <div className="relative mx-auto max-w-[760px] px-5 pt-12 sm:px-8 sm:pt-20">
        <h1 className="text-balance text-center text-[38px] font-semibold leading-[1.05] tracking-[-0.04em] text-ink-900 sm:text-[52px]">
          Perfeito! <span className="text-brand-600">Processo iniciado.</span>
        </h1>

        <div className="mt-10 rounded-3xl border border-ink-900/[0.08] bg-white p-6 shadow-[0_30px_70px_-40px_rgb(44_24_128/.35)] sm:p-10">
          <h2 className="text-2xl font-semibold tracking-[-0.02em] text-ink-900">Próximos passos:</h2>
          <ol className="mt-6 space-y-5">
            {NEXT_STEPS.map((step, index) => (
              <li key={index} className="flex items-start gap-4">
                <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-brand-600 font-mono text-[13px] font-medium text-white">
                  {index + 1}
                </span>
                <p className="pt-1 text-[17px] leading-snug text-ink-700">{step}</p>
              </li>
            ))}
          </ol>

          <div className="mt-8 rounded-2xl border border-brand-100 bg-brand-50 p-6">
            <h3 className="flex items-center gap-2 text-lg font-semibold text-ink-900">
              <Brain className="h-5 w-5 text-brand-600" aria-hidden="true" />
              Por que uma IA primeiro?
            </h3>
            <ul className="mt-4 space-y-3">
              {WHY_AI_FIRST.map(({ icon: Icon, text }) => (
                <li key={text} className="flex items-center gap-3 text-[16px] text-ink-700">
                  <Icon className="h-4 w-4 text-brand-600" aria-hidden="true" />
                  {text}
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-8 space-y-5 text-center">
            <p className="text-[17px] leading-relaxed text-ink-700">
              Somos uma <strong className="font-semibold text-ink-900">consultoria e software house</strong> focada em IA e
              dados. <strong className="font-semibold text-brand-700">Luisa é a prova de que nossa tecnologia funciona.</strong>
            </p>
            <p className="rounded-2xl bg-night p-5 text-[14px] leading-relaxed text-white/75">
              <strong className="font-semibold text-white">P.S.:</strong> Sim, Luisa é nossa própria tecnologia. Se não
              confiássemos nela para qualificar nossos leads,{" "}
              <strong className="font-semibold text-brand-300">
                por que você confiaria em nós para implementar IA no seu negócio?
              </strong>
            </p>
          </div>
        </div>
      </div>
    </main>

    <Footer showNav={false} />
  </div>
);

export default ThankYou;
